<template>
  <v-container fluid>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Партнеры
      </v-card-title>
    </v-card>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
                <v-btn
                    @click="addPartner"
                    depressed
                    color="primary"
                >
                  <v-icon
                      left
                      dark
                  >
                    mdi-plus
                  </v-icon>
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
              class="mr-2"
              @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>

export default {
  name: 'AdminPartners',
  data() {
    return {
      roles: [
        { value: "ROLE_ADMIN", name: "Админ" },
        { value: "ROLE_PARTNER", name: "Партнер" },
        { value: "ROLE_USER", name: "Пользователь" },
      ],
      editedItem: {
        username: '+7',
        name: '',
        surname: '',
        patronymic: '',
        password: '',
        email: '',
        role: 'ROLE_USER',
      },
      editDialog: false,
      data: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Наименование', value: 'name' },
        { text: 'Адрес', value: 'address' },
        { text: 'Ссылка', value: 'link' },
        { text: 'Телефон', value: 'email' },
        { text: 'Дата создания', value: 'email' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {},
      jobs: [],
      categories: [],
      isEditing: false,
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        const data = await this.$store.dispatch('adminController/getAllPartners')
        this.data = data.map((item) => {
          item.fullName = item.name + ' ' + item.surname
          return item
        })
      } catch (e) {
        console.log(e)
      }
    },
    addPartner() {
      this.$router.push('/admin/partners/add')
    },
    editItem (item) {
      this.$router.push('/admin/partners/add/' + item.id)
    },

  }
}
</script>
<style scoped>

</style>